// extracted by mini-css-extract-plugin
export default {"bodyLoader":"BodyLoader_bodyLoader__9zPls"};